import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'
import { getAffiliateLink, getAffiliateLogoPath, getAffiliateName, getBaseSlugFromUrl, getProfileImagePaths } from '../config/site'
import citiesData from '../utils/getCitiesData'
import './StickyButton.css'

const StickyButton = () => {
  const location = useLocation()
  const { t } = useLocale()
  const [cityName, setCityName] = useState(null)
  const [onlineCount, setOnlineCount] = useState(0)

  // Generate dynamic number between 1000-2000
  useEffect(() => {
    const min = 1000
    const max = 2000
    const count = Math.floor(Math.random() * (max - min + 1)) + min
    setOnlineCount(count)
  }, [])

  useEffect(() => {
    // Check if we're on a city page
    const pathSlug = location.pathname.split('/').pop()
    const baseSlug = getBaseSlugFromUrl(pathSlug)
    const city = citiesData.find(c => c.Slug.toLowerCase() === baseSlug?.toLowerCase())
    if (city) {
      setCityName(city.City)
    } else {
      setCityName(null)
    }
  }, [location])

  const handleClick = () => {
    window.open(getAffiliateLink(), '_blank', 'noopener,noreferrer')
  }

  const buttonText = cityName 
    ? t('cta.stickyButton.withCity', { city: cityName })
    : t('cta.stickyButton.default')

  // Profile images for sticky button (show 3-4 profiles)
  const profileImages = getProfileImagePaths(4)

  const brandName = getAffiliateName() || t('common.siteName')

  return (
    <button 
      className="sticky-button"
      onClick={handleClick}
      aria-label={buttonText}
    >
      {/* Logo and Brand */}
      <div className="sticky-logo-section">
        <img 
          src={getAffiliateLogoPath()} 
          alt={brandName}
          className="sticky-logo"
        />
        <span className="sticky-brand-name">{brandName}</span>
      </div>

      {/* Profile Images */}
      <div className="sticky-profiles">
        {profileImages.map((img, index) => (
          <div key={index} className="sticky-profile-wrapper">
            <img 
              src={img} 
              alt={`Profile ${index + 1}`}
              className="sticky-profile-image"
              loading="lazy"
            />
            <span className="sticky-online-indicator"></span>
          </div>
        ))}
      </div>

      {/* Online Count */}
      <div className="sticky-online-info">
        <span className="sticky-online-count">
          {onlineCount.toLocaleString('de-DE')} {t('cta.stickyButton.online')}
        </span>
      </div>

      {/* Button Text */}
      <span className="sticky-button-text">{buttonText}</span>
    </button>
  )
}

export default StickyButton

